<template>
  <div>
    <v-row>
      <v-col md="9">
      </v-col>
      <v-col md="3">
        <v-text-field
          v-model="search"
          class="mt-n8 pr-4 mb-2"
          clearable
          @click:clear="clearSearch"
          @keydown.enter="doSearch"
          prepend-icon="$sl-search"
          placeholder="Sök i listan"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <NotesList 
      :refresh="refresh" 
      :modifier="{ personId: this.selectedPerson.id }" 
      :search="searchcriteria" 
      :comments="comments"
    />

    <v-btn data-cy="add-new-note" absolute bottom right fab @click="notesModal=true" :disabled="!canCreateNotes">
      <v-icon class="ml-1">$sl-add</v-icon>
    </v-btn>

    <NotesEditModal v-model="notesModal" :personId="this.selectedPerson.id" @saved="refresh=!refresh"/>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NotesEditModal from '@/components/NotesEditModal.vue'
import NotesList from '@/components/NotesList.vue'
import { CanIDo } from '@/components/mixins'
import get from 'lodash/get'
import flatMap from 'lodash/flatMap'

export default {
  mixins: [CanIDo],
  data: () => ({
    searchcriteria: null,
    search: '',
    refresh: false,
    notesModal: false
  }),

  components: {
    NotesEditModal,
    NotesList
  },

  computed: {
    ...mapGetters('person', ['selectedPerson']),

    comments() {
      const distanceOrders = get(this, 'selectedPerson.distanceOrders', [])
      if ( distanceOrders.length )
        return flatMap(distanceOrders, 'comments')

      return []
    }
  },

  asyncComputed: {
    canCreateNotes(){
      return this.canIDo('notes', 'create');
    },
  },

  methods: {
    clearSearch(e) {
      this.searchcriteria = null
      return false
    },

    doSearch(e) {
      e.preventDefault()
      this.searchcriteria = this.search
    }
  }

}
</script>

<style>
</style>